import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { COLOR } from '@src/styles/color';
import { NEW_SIDEBAR_WIDTH, SIDEBAR_BOX_SHADOW } from '@src/styles/config';

// Collapsed the trigger is only an icon wide, so the panel falls back to the
// sidebar's own width instead of measuring it.
const SWITCHER_PANEL_WIDTH = NEW_SIDEBAR_WIDTH - 24;

export const StyledProductSwitcher = styled('div')`
  /* 12px above and below the trigger; the list below adds 8 of its own. */
  padding: 12px 0 4px;

  .switcher-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 8.5px;
    box-sizing: border-box;
    border: 0.5px solid ${COLOR.indigo[16]};
    border-radius: 8px;
    cursor: pointer;
    /* Chrome rings a tabbable div even on a plain click. */
    outline: none;

    &:hover {
      background-color: ${COLOR.charcoalV2[64]};
    }
  }

  .switcher-trigger-collapsed {
    justify-content: center;
  }

  /* Both assets bake in their own rounded corners and border. */
  .trigger-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  .switcher-label {
    flex: 1;
    min-width: 0;
    color: ${COLOR.label2[100]};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .switcher-caret {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: ${COLOR.indigo[64]};
  }
`;

export const StyledSwitcherPanel = styled(Box)`
  background-color: ${COLOR.white};
  border-radius: 8px;
  box-shadow: ${SIDEBAR_BOX_SHADOW};
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  /* Grows past the sidebar so each description keeps to one line, and never
     narrows below the trigger it hangs from. */
  width: max-content;
  min-width: ${`${SWITCHER_PANEL_WIDTH}px`};
  max-width: calc(100vw - 32px);

  .switcher-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    outline: none;

    &:hover {
      background-color: ${COLOR.charcoalV2[64]};
    }
  }

  .switcher-item-active {
    background-color: ${COLOR.indigo[4]};
  }

  .item-icon {
    width: 32px;
    height: 32px;
    flex-shrink: 0;
  }

  .switcher-item-text {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .switcher-item-title {
    color: ${COLOR.label2[100]};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.4px;
  }

  .switcher-item-description {
    color: ${COLOR.label2[64]};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    white-space: nowrap;
  }
`;
